export const routeTitleMap: Record<string, string> = {
  '/': 'Home',
  '/Home': 'Home',
  '/Policy': 'Policy',
  '/Create': 'Create',
  '/Create/:char_uuid': 'Edit Character',
  '/Credits': 'Credits',
  '/Archive': 'Archive',
  '/Profile/:creator_uuid': 'Profile',
  '/Chat/:chat_uuid': 'Chat',
  '/Settings': 'Settings',
  '/ContentPolicy': 'Content Policy',
  '/docs': 'Docs',
  '/docs/:doc_name': 'Docs',
  '/Admin': 'Admin',
  '/character/:char_uuid': 'Character',
  '/Blocked': 'Blocked',
  '/Themes': 'Themes',
  '/ImageGen': 'Free Image Generator',
  '*': 'Page Not Found',
};
